<template>
  <div id="account-wrapper" v-if="!form">
    <h3 class="account-title txt-grad-color-2">EDITAR PERFIL</h3>

    <button
      type="button"
      class="account-card-border"
      @click="handleFormChoice('personal')"
    >
      <div class="account-card">
        <b-icon class="account-card-icon" icon="person-fill"></b-icon>

        <b-icon class="account-card-arrow" icon="arrow-right"></b-icon>

        <p class="account-card-txt txt-bold">Información personal</p>
      </div>
    </button>

    <button
      type="button"
      class="account-card-border"
      @click="handleFormChoice('account')"
    >
      <div class="account-card">
        <b-icon class="account-card-icon" icon="key-fill"></b-icon>

        <b-icon class="account-card-arrow" icon="arrow-right"></b-icon>

        <p class="account-card-txt txt-bold">Información de cuenta</p>
      </div>
    </button>

    <button
      type="button"
      class="account-gohome-btn txt-bold"
      @click="handleSectionChange('home')"
    >
      Volver al inicio
    </button>
  </div>
  <div id="account-form-wrapper" v-else>
    <h3 class="account-title txt-grad-color-2">EDITAR PERFIL</h3>

    <form
      class="account-form"
      @submit.prevent="handlePersonalSubmit"
      v-if="selectedForm === 'personal'"
    >
      <p class="account-form-title">
        Editar tu <span class="txt-bold">información personal</span>
      </p>

      <label class="account-label" for="account-nombre"
        >Nombre:
        <input
          id="account-nombre"
          class="account-input"
          :class="{ 'account-invalid-input': errorsPersonalForm.nombre }"
          type="text"
          v-model="accountForm.nombres"
          @blur="validateNombre"
          ref="accountNombre"
        />

        <span class="account-required"></span>

        <p
          v-if="errorsPersonalForm.nombre"
          class="account-invalid-feedback txt-bold"
        >
          {{ errorsPersonalForm.nombre }}
        </p>
      </label>

      <label class="account-label" for="account-apellido"
        >Apellido:
        <input
          id="account-apellido"
          class="account-input"
          :class="{ 'account-invalid-input': errorsPersonalForm.apellido }"
          type="text"
          v-model="accountForm.apellidos"
          @blur="validateApellido"
          ref="accountApellido"
        />

        <span class="account-required"></span>

        <p
          v-if="errorsPersonalForm.apellido"
          class="account-invalid-feedback txt-bold"
        >
          {{ errorsPersonalForm.apellido }}
        </p>
      </label>

      <label class="account-label" for="account-profesion"
        >Profesión/Cargo:
        <input
          id="account-profesion"
          class="account-input"
          :class="{ 'account-invalid-input': errorsPersonalForm.profesion }"
          type="text"
          v-model="accountForm.profesion"
          @blur="validateProfesion"
          ref="accountProfesion"
        />

        <span class="account-required"></span>

        <p
          v-if="errorsPersonalForm.profesion"
          class="account-invalid-feedback txt-bold"
        >
          {{ errorsPersonalForm.profesion }}
        </p>
      </label>

      <label class="account-label" for="account-empresa"
        >Institución/Empresa:
        <input
          id="account-empresa"
          class="account-input"
          :class="{ 'account-invalid-input': errorsPersonalForm.empresa }"
          type="text"
          v-model="accountForm.institucion"
          @blur="validateEmpresa"
          ref="accountEmpresa"
        />

        <span class="account-required"></span>

        <p
          v-if="errorsPersonalForm.empresa"
          class="account-invalid-feedback txt-bold"
        >
          {{ errorsPersonalForm.empresa }}
        </p>
      </label>

      <!-- <label class="account-label" for="account-pais"
        >País:
        <input
          id="account-pais"
          class="account-input"
          :class="{ 'account-invalid-input': errorsPersonalForm.pais }"
          type="text"
          v-model="accountForm.pais"
          @blur="validatePais"
          ref="accountPais"
        />

        <span class="account-required"></span>

        <p
          v-if="errorsPersonalForm.pais"
          class="account-invalid-feedback txt-bold"
        >
          {{ errorsPersonalForm.pais }}
        </p>
      </label> -->

      <label class="account-label" for="account-pais">
        País:

        <span class="account-required"></span>

        <select
          class="account-select"
          :class="{ 'account-invalid-input': errorsPersonalForm.pais }"
          name="account-pais"
          id="account-pais"
          v-model="accountForm.cod_pais"
          @change="validatePais"
          ref="accountPais"
        >
          <option value="" disabled>Seleccionar</option>
          <option
            v-for="(pais, index) in arrayPaises"
            :value="pais.str_codigo_pais"
            :key="index"
          >
            {{ pais.str_nombre_pais }}
          </option>
        </select>

        <p
          v-if="errorsPersonalForm.pais"
          class="account-invalid-feedback txt-bold"
        >
          {{ errorsPersonalForm.pais }}
        </p>
      </label>

      <label class="account-label" for="account-localidad"
        >Localidad:
        <input
          id="account-localidad"
          class="account-input"
          :class="{ 'account-invalid-input': errorsPersonalForm.localidad }"
          type="text"
          v-model="accountForm.localidad"
          @blur="validateLocalidad"
          ref="accountLocalidad"
        />

        <span class="account-required"></span>

        <p
          v-if="errorsPersonalForm.localidad"
          class="account-invalid-feedback txt-bold"
        >
          {{ errorsPersonalForm.localidad }}
        </p>
      </label>

      <div class="account-btn-container">
        <button
          type="button"
          class="account-back-btn txt-bold"
          @click="handleGoBack"
        >
          <b-icon icon="arrow-left"></b-icon>
          Volver
        </button>

        <button type="submit" class="account-grad-btn" :disabled="saving">
          <span class="txt-bold">
            <div class="lds-ring" v-if="saving">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            {{ saving ? "Guardando..." : "Guardar" }}
          </span>
        </button>
      </div>
    </form>

    <form
      class="account-form"
      v-if="selectedForm === 'account'"
      @submit.prevent="handleAccountSubmit"
    >
      <p class="account-form-title">
        Editar la <span class="txt-bold">información de tu cuenta</span>
      </p>

      <label class="account-label" for="account-correo">
        Correo Electrónico:
        <input
          id="account-correo"
          class="account-input"
          :class="{ 'account-invalid-input': errorsAccountForm.correo }"
          type="email"
          autocomplete="email"
          v-model="accountForm.correo"
          @blur="validateCorreo"
          ref="accountCorreo"
        />

        <span class="account-required"></span>

        <p
          v-if="errorsAccountForm.correo"
          class="account-invalid-feedback txt-bold"
        >
          {{ errorsAccountForm.correo }}
        </p>
      </label>

      <label class="account-label" for="account-usuario">
        Usuario:
        <input
          id="account-usuario"
          class="account-input"
          :class="{ 'account-invalid-input': errorsAccountForm.usuario }"
          type="text"
          v-model="accountForm.usuario"
          @blur="validateUsuario"
          ref="accountUsuario"
        />

        <span class="account-required"></span>

        <p
          v-if="errorsAccountForm.usuario"
          class="account-invalid-feedback txt-bold"
        >
          {{ errorsAccountForm.usuario }}
        </p>
      </label>

      <label class="account-label" for="account-actual-password">
        Contraseña Actual:
        <input
          id="account-actual-password"
          class="account-input"
          :class="{ 'account-invalid-input': errorsAccountForm.actualPassword }"
          :type="showPassword ? 'text' : 'password'"
          :autocomplete="showPassword ? 'none' : 'new-password'"
          v-model="accountForm.clave_actual"
          ref="accountActualPassword"
        />

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          fill="currentColor"
          class="bi bi-eye-fill account-eye-icon"
          viewBox="0 0 16 16"
          @click="showPassword = !showPassword"
        >
          <defs>
            <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop
                offset="0%"
                style="stop-color: rgb(0, 246, 187); stop-opacity: 1"
              />
              <stop
                offset="100%"
                style="stop-color: rgb(29, 143, 206); stop-opacity: 1"
              />
            </linearGradient>
          </defs>
          <path
            fill="url(#grad2)"
            d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"
          />
          <path
            fill="url(#grad2)"
            d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
          />
        </svg>
      </label>

      <label class="account-label" for="account-password">
        Contraseña:
        <input
          id="account-password"
          class="account-input"
          :class="{ 'account-invalid-input': errorsAccountForm.password }"
          :type="showPassword ? 'text' : 'password'"
          :autocomplete="showPassword ? 'none' : 'new-password'"
          v-model="accountForm.clave"
          ref="accountPassword"
        />
      </label>

      <label class="account-label" for="account-password-repeat">
        Confirmar Contraseña:
        <input
          id="account-password-repeat"
          class="account-input"
          :class="{ 'account-invalid-input': errorsAccountForm.password }"
          :type="showPassword ? 'text' : 'password'"
          :autocomplete="showPassword ? 'none' : 'new-password'"
          v-model="accountForm.claveRepeat"
        />

        <p
          v-if="errorsAccountForm.password"
          class="account-invalid-feedback txt-bold"
        >
          {{ errorsAccountForm.password }}
        </p>
      </label>

      <div class="account-btn-container">
        <button
          type="button"
          class="account-back-btn txt-bold"
          @click="handleGoBack"
        >
          <b-icon icon="arrow-left"></b-icon>
          Volver
        </button>

        <button type="submit" class="account-grad-btn" :disabled="saving">
          <span class="txt-bold">
            <div class="lds-ring" v-if="saving">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            {{ saving ? "Guardando..." : "Guardar" }}
          </span>
        </button>
      </div>
    </form>

    <b-modal
      v-model="modalAccount.show"
      id="account-modal-delete"
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <template #modal-header>
        <h5 class="modal-title">{{ modalAccount.title }}</h5>
      </template>

      <div class="account-modal-delete-body">
        <p class="account-modal-delete-txt" v-html="modalAccount.text"></p>
      </div>

      <template #modal-footer>
        <!-- <button
          type="button"
          class="account-modal-delete-normal-btn txt-bold"
          @click="modalAccount.show = false"
        >
          {{ modalAccount.normalBtnText }}
        </button> -->

        <button
          type="button"
          class="account-modal-delete-grad-btn"
          @click="handleCloseModal"
        >
          <span class="txt-bold">{{ modalAccount.gradBtnText }}</span>
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import MEC_Paises_api from "@/modules/MEC_Paises_api";
import MEC_Funcionarios_api from "@/modules/MEC_Funcionarios_api";

export default {
  data() {
    return {
      arrayPaises: [],
      saving: false,
      form: false,
      selectedForm: "personal",
      errorsPersonalForm: {},
      focusPersonalForm: [],
      errorsAccountForm: {},
      focusAccountForm: [],
      showPassword: false,
      accountForm: {
        Id_funcionario: 0,
        id_tipo_identificacion: 1,
        id_perfil: 1,
        usr_LDAP: "",
        habilitado: 1,
        identificacion: "1",
        nombres: "",
        apellidos: "",
        telefono: "",
        profesion: "",
        institucion: "",
        cod_pais: "",
        localidad: "",
        correo: "",
        usuario: "",
        clave: "",
        claveRepeat: "",
        clave_actual: "",
      },
      modalAccount: {
        show: false,
        title: "Cuenta",
        text: "",
        normalBtnText: "",
        gradBtnText: "",
      },
    };
  },

  props: ["userDataAccount", "idFuncionario"],

  async mounted() {
    const apiPaises = new MEC_Paises_api();

    await apiPaises
      .find("")
      .then((result) => {
        this.arrayPaises = result.data.result;
      })
      .catch((err) => {
        console.log(err);
      });

    this.assignData();
  },

  methods: {
    assignData() {
      this.accountForm.Id_funcionario = this.userDataAccount.Id_funcionario;
      this.accountForm.nombres = this.userDataAccount.nombres;
      this.accountForm.apellidos = this.userDataAccount.apellidos;
      this.accountForm.profesion = this.userDataAccount.profesion;
      this.accountForm.institucion = this.userDataAccount.institucion;
      this.accountForm.cod_pais = this.userDataAccount.cod_pais;
      this.accountForm.localidad = this.userDataAccount.localidad;
      this.accountForm.correo = this.userDataAccount.correo;
      this.accountForm.usuario = this.userDataAccount.usuario;
      this.accountForm.clave = "";
      this.accountForm.claveRepeat = "";
      this.accountForm.clave_actual = "";
    },

    async handlePersonalSubmit() {
      const apiFuncionarios = new MEC_Funcionarios_api();

      if (!this.validatePersonalForm()) {
        return;
      }

      this.saving = true;

      apiFuncionarios
        .update(this.accountForm)
        .then((result) => {
          console.log(result);
          if (result.data.rowsAffected && result.data.rowsAffected == 1) {
            this.saving = false;
            this.modalAccount.show = true;
            this.modalAccount.gradBtnText = "Aceptar";
            this.modalAccount.title = "Datos actualizados";
            this.modalAccount.text = `Los datos han sido actualizados correctamente`;
          } else {
            this.saving = false;
            this.modalAccount.show = true;
            this.modalAccount.gradBtnText = "Aceptar";
            this.modalAccount.title = "Error";
            this.modalAccount.text = `Ha ocurrido un error, vueleve a intentarlo.`;
          }
        })
        .catch((err) => {
          this.saving = false;
          console.log(err);
        });
    },

    handleAccountSubmit() {
      const apiFuncionarios = new MEC_Funcionarios_api();

      if (!this.validateAccountForm()) {
        return;
      }

      this.saving = true;

      apiFuncionarios
        .update(this.accountForm)
        .then((result) => {
          console.log(result);
          if (result.data.rowsAffected && result.data.rowsAffected == 1) {
            this.saving = false;
            this.modalAccount.show = true;
            this.modalAccount.gradBtnText = "Aceptar";
            this.modalAccount.title = "Datos actualizados";
            this.modalAccount.text = `Los datos han sido actualizados correctamente`;
          } else if (result.data.error) {
            this.saving = false;
            this.modalAccount.show = true;
            this.modalAccount.gradBtnText = "Aceptar";
            this.modalAccount.title = "Error";
            this.modalAccount.text = `${result.data.error}`;
          } else {
            this.saving = false;
            this.modalAccount.show = true;
            this.modalAccount.gradBtnText = "Aceptar";
            this.modalAccount.title = "Error";
            this.modalAccount.text = `Ha ocurrido un error, vueleve a intentarlo.`;
          }
        })
        .catch((err) => {
          this.saving = false;
          console.log(err);
        });
    },

    validatePersonalForm() {
      this.errorsPersonalForm = {};
      this.focusPersonalForm = [];

      this.validateNombre();
      this.validateApellido();
      this.validateProfesion();
      this.validateEmpresa();
      this.validatePais();
      this.validateLocalidad();

      if (this.focusPersonalForm.length > 0) {
        this.focusInput(this.focusPersonalForm[0]);
      }

      return Object.keys(this.errorsPersonalForm).length === 0;
    },

    validateAccountForm() {
      this.errorsAccountForm = {};
      this.focusAccountForm = [];

      this.validateCorreo();
      this.validateUsuario();

      if (this.focusAccountForm.length > 0) {
        this.focusInput(this.focusAccountForm[0]);
      }

      return Object.keys(this.errorsAccountForm).length === 0;
    },

    validateNombre() {
      this.accountForm.nombres = this.accountForm.nombres.trim();

      if (!this.accountForm.nombres) {
        this.errorsPersonalForm.nombre = "El nombre es requerido";
        this.focusPersonalForm.push("accountNombre");
      } else {
        this.errorsPersonalForm.nombre = "";
        delete this.errorsPersonalForm.nombre;
      }
    },

    validateApellido() {
      this.accountForm.apellidos = this.accountForm.apellidos.trim();

      if (!this.accountForm.apellidos) {
        this.errorsPersonalForm.apellido = "El apellido es requerido";
        this.focusPersonalForm.push("accountApellido");
      } else {
        this.errorsPersonalForm.apellido = "";
        delete this.errorsPersonalForm.apellido;
      }
    },

    validateProfesion() {
      this.accountForm.profesion = this.accountForm.profesion.trim();

      if (!this.accountForm.profesion) {
        this.errorsPersonalForm.profesion = "La Profesión/Cargo es requerida/o";
        this.focusPersonalForm.push("accountProfesion");
      } else {
        this.errorsPersonalForm.profesion = "";
        delete this.errorsPersonalForm.profesion;
      }
    },

    validateEmpresa() {
      this.accountForm.institucion = this.accountForm.institucion.trim();

      if (!this.accountForm.institucion) {
        this.errorsPersonalForm.empresa = "La Institución/Empresa es requerida";
        this.focusPersonalForm.push("accountEmpresa");
      } else {
        this.errorsPersonalForm.empresa = "";
        delete this.errorsPersonalForm.empresa;
      }
    },

    validatePais() {
      this.accountForm.cod_pais = this.accountForm.cod_pais.trim();

      if (!this.accountForm.cod_pais) {
        this.errorsPersonalForm.pais = "Debe seleccionar un país";
        this.focusPersonalForm.push("accountPais");
      } else {
        this.errorsPersonalForm.pais = "";
        delete this.errorsPersonalForm.pais;
      }
    },

    validateLocalidad() {
      this.accountForm.localidad = this.accountForm.localidad.trim();

      if (!this.accountForm.localidad) {
        this.errorsPersonalForm.localidad = "La localidad es requerida";
        this.focusPersonalForm.push("accountLocalidad");
      } else {
        this.errorsPersonalForm.localidad = "";
        delete this.errorsPersonalForm.localidad;
      }
    },

    validateCorreo() {
      this.accountForm.correo = this.accountForm.correo.trim();

      // Regular Expression para comprobar que el email sea valido
      const emailRe =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!this.accountForm.correo) {
        this.errorsAccountForm.correo = "El correo es requerido";
        this.focusAccountForm.push("accountCorreo");
      } else if (!emailRe.test(this.accountForm.correo)) {
        this.errorsAccountForm.correo = "Ingresa un correo válido";
        this.focusAccountForm.push("accountCorreo");
      } else {
        this.errorsAccountForm.correo = "";
        delete this.errorsAccountForm.correo;
      }
    },

    validateUsuario() {
      this.accountForm.usuario = this.accountForm.usuario.trim();

      if (!this.accountForm.usuario) {
        this.errorsAccountForm.usuario = "El usuario es requerido";
        this.focusAccountForm.push("accountUsuario");
      } else {
        this.errorsAccountForm.usuario = "";
        delete this.errorsAccountForm.usuario;
      }
    },

    validatePassword() {
      // Regular Expression para que la contraseña tenga al menos 8 caracteres entre los cuales debe haber: una letra mayúscula, una letra minúscula y un número
      const pssRe =
        /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?!.*\s).{8,}$/;

      this.accountForm.clave = this.accountForm.clave.trim();
      this.accountForm.claveRepeat = this.accountForm.claveRepeat.trim();

      if (!this.accountForm.clave) {
        this.errorsAccountForm.password = "La contraseña es requerida";
        this.focusAccountForm.push("accountPassword");
      } else if (this.accountForm.clave != this.accountForm.claveRepeat) {
        this.errorsAccountForm.password = "Las contraseñas no coinciden";
        this.focusAccountForm.push("accountPassword");
      } else if (!pssRe.test(this.accountForm.clave)) {
        this.errorsAccountForm.password =
          "La contraseña debe contener al menos 8 caracteres entre los cuales debe haber: una letra mayúscula, una letra minúscula y un número";
        this.focusAccountForm.push("accountPassword");
      } else {
        this.errorsAccountForm.password = "";
        delete this.errorsAccountForm.password;
      }
    },

    focusInput(inputRef) {
      this.$nextTick(() => {
        this.$refs[inputRef].focus();
      });
    },

    handleFormChoice(formName) {
      this.selectedForm = formName;
      this.form = true;
    },

    handleGoBack() {
      this.errorsPersonalForm = {};
      this.focusPersonalForm = [];
      this.errorsAccountForm = {};
      this.focusAccountForm = [];
      this.form = false;
    },

    handleCloseModal() {
      this.$emit("getDatosSesion");
      this.modalAccount.show = false;
      this.handleGoBack();
      this.assignData();
    },

    handleSectionChange(section) {
      this.$emit("sectionChange", { section, lastSection: "account" });
    },
  },
};
</script>

<style>
#account-wrapper,
#account-form-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 500px;
}

.account-title {
  margin-bottom: 70px;
  text-align: center;
  font-family: var(--special-font);
  color: var(--white);
  font-size: 40px;
}

.account-card-border {
  all: unset;
  cursor: pointer;
  margin: 50px auto;
  width: 90%;
  max-width: 400px;
  height: 120px;
  background-image: var(--grad-color-2);
  border-radius: 15px;
  padding: 2px;
  transition: transform 0.5s ease-in-out;
}

.account-card-border:focus,
.account-card-border:hover {
  transform: scale(1.05);
}

.account-card {
  width: 100%;
  height: 100%;
  background-color: var(--black);
  border-radius: 13px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 80px;
  grid-template-rows: repeat(2, minmax(0, 1fr));
  grid-template-areas:
    "icon arrow"
    "txt txt";
  padding: 0 15px;
  align-items: center;
}

.account-card-icon {
  grid-area: icon;
  color: var(--white);
  font-size: 35px;
}

.account-card-arrow {
  grid-area: arrow;
  color: var(--white);
  font-size: 30px;
  transition: transform 0.3s ease-in-out;
}

.account-card:hover .account-card-arrow {
  transform: translateX(15px);
}

.account-card-txt {
  grid-area: txt;
  color: var(--white);
  font-size: 20px;
}

.account-gohome-btn {
  all: unset;
  margin: 0 auto;
  padding: 1rem;
  color: var(--white);
  border-radius: 15px;
  transition: color 0.3s ease-in-out;
}

.account-gohome-btn:focus {
  outline: 1px solid var(--white);
  outline-offset: 2px;
}

.account-gohome-btn:hover {
  color: var(--hover-white);
}

.account-form {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 340px;
  gap: 20px;
}

.account-form-title {
  color: var(--white);
  text-align: center;
}

.account-label {
  width: 100%;
  color: var(--white);
  font-weight: 700;
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
}

.account-required {
  position: absolute;
  top: -0.7rem;
  left: -0.7rem;
}

.account-required::after {
  content: "*";
  position: absolute;
  top: 0;
  left: 0;
  color: var(--accent-color);
  font-size: 20px;
}

.account-eye-icon {
  position: absolute;
  right: 5%;
  top: 58%;
  cursor: pointer;
}

.account-input {
  outline: none;
  padding: 0 1rem;
  width: 100%;
  height: 48px;
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: 15px;
  color: var(--white);
}

.account-input:focus {
  border: 1px solid var(--accent-color);
  box-shadow: 0 0 0.5rem 1px #49fffcbc;
}

.account-select {
  appearance: none;
  outline: none;
  cursor: pointer;
  font: inherit;
  padding: 0 1rem;
  width: 100%;
  height: 48px;
  background-color: var(--input-bg);
  background: url(https://upload.wikimedia.org/wikipedia/commons/9/9d/Caret_down_font_awesome_whitevariation.svg)
      no-repeat right 0.8em center / 1.4em,
    var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: 15px;
  color: var(--white);
}

.account-select option {
  all: unset;
  background-color: var(--input-border);
  width: 300px;
}

.account-invalid-feedback {
  margin: 0;
  color: red;
  font-size: 12px;
  width: 100%;
  text-align: center;
}

.account-invalid-input {
  border: 1px solid red;
}

.account-invalid-input:focus {
  border: 1px solid red;
  box-shadow: 0 0 1rem 5px #ff5c5cbc;
}

.account-error-txt {
  margin: 0;
  width: 100%;
  color: red;
  text-align: center;
}

.account-btn-container {
  display: flex;
  justify-content: space-between;
}

.account-back-btn {
  all: unset;
  padding: 1rem;
  color: var(--white);
  border-radius: 15px;
  transition: color 0.3s ease-in-out;
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.account-back-btn:focus {
  outline: 1px solid var(--white);
  outline-offset: 2px;
}

.account-back-btn:hover {
  color: var(--hover-white);
}

.account-back-btn svg {
  transition: transform 0.3s ease-in-out;
}

.account-back-btn:hover svg {
  transform: translateX(-5px);
}

.account-grad-btn {
  border: none;
  outline: none;
  width: 150px;
  height: 48px;
  padding: 2px;
  background-image: var(--grad-color-2);
  border-radius: 15px;
}

.account-grad-btn span {
  width: 100%;
  height: 100%;
  background-color: var(--black);
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  color: var(--white);
  border-radius: 13px;
  transition: background 0.3s ease-in-out;
}

.account-grad-btn:hover span {
  background-color: transparent;
}

.account-grad-btn:disabled {
  background-image: none;
  background-color: var(--input-border);
  cursor: not-allowed;
}

.account-grad-btn:disabled span {
  color: var(--input-border);
}

.account-grad-btn:disabled span .lds-ring div {
  border: 4px solid var(--input-border);
  border-color: var(--input-border) transparent transparent transparent;
}

/* ---------------------------------------------- Estilos modal cuenta */
#account-modal-delete {
  font-family: var(--main-font);
}

#account-modal-delete + .modal-backdrop {
  background: rgba(0, 0, 0, 0.21);
  backdrop-filter: blur(7px);
}

#account-modal-delete .modal-content {
  background-color: var(--black);
  border-radius: 20px;
  border: double 1px transparent;
  background-image: linear-gradient(var(--black), var(--black)),
    var(--grad-color-2);
  background-origin: border-box;
  background-clip: padding-box, border-box;
}

#account-modal-delete .modal-header {
  padding: 2rem 0;
  border: none;
  position: relative;
}

.account-modal-delete-close-btn {
  all: unset;
  cursor: pointer;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  font-size: 35px;
  color: var(--white);
  transition: color 0.3s ease-in-out;
}

.account-modal-delete-close-btn:hover {
  color: var(--hover-white);
}

#account-modal-delete .modal-header .modal-title {
  width: 100%;
  font-weight: 700;
  text-align: center;
  color: var(--white);
}

.account-modal-delete-body {
  width: 100%;
}

.account-modal-delete-txt {
  text-align: center;
  color: var(--white);
}

#account-modal-delete .modal-footer {
  border: none;
  justify-content: center;
}

.account-modal-delete-normal-btn {
  all: unset;
  cursor: pointer;
  width: 150px;
  height: 48px;
  border-radius: 15px;
  color: var(--white);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: color 0.3s ease-in-out;
}

.account-modal-delete-normal-btn:hover {
  color: var(--hover-white);
}

.account-modal-delete-grad-btn {
  all: unset;
  cursor: pointer;
  width: 150px;
  height: 48px;
  padding: 2px;
  background-image: var(--grad-color-2);
  border-radius: 15px;
}

.account-modal-delete-grad-btn span {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--black);
  color: var(--white);
  border-radius: 13px;
  transition: background 0.3s ease-in-out;
}

.account-modal-delete-grad-btn:hover span {
  background-color: transparent;
}

.account-modal-delete-normal-btn:focus,
.account-modal-delete-grad-btn:focus {
  outline: 1px solid var(--white);
  outline-offset: 2px;
}
</style>
